import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const flashSaleRBAC = {
  pageID: 'c825c5f17003b1f9d0f6f36d779b09bc',
  elementID: {
    ViewFlashSale: '791c46d09ac8b8ba75cdd17d09ba0baa',
    EditFlashSale: '9ee858d98c81beac69e3d7017c4fb18f',
    DeleteFlashSale: 'a95c2c83d3401c04fd5ab64708b8dac8',
    CreateFlashSale: '10c7062b61f4e2c525d20797de21aadf',
  },
} as const

export const useRBACFlashSalePage = createUseRBAC(flashSaleRBAC.elementID)

export type UseRBACFlashSalePageType = ReturnType<typeof useRBACFlashSalePage>
